import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls the window back to the top on every route (pathname) change,
// so arriving on a new page always starts at the top.
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
